import React from 'react';
import ChildMenus from './ChildMenus';

export default function ListMenu(item) {

    var url = "javascript:void(0);";

    if (null == item.item.submenu) {
        url = item.item.url;
    }

    if (window.location.pathname.includes(item.item.folder)) {
        return (
            <li className={'active'}>
                <a href={url}>{item.item.name}</a>
                <ChildMenus submenu={item.item.submenu} />
            </li>
        );
    } else {
        return (
            <li>
                <a href={url}>{item.item.name}</a>
                <ChildMenus submenu={item.item.submenu} />
            </li>
        );
    }
}
